import {
    DATE_RANGE_ANY, DATE_RANGE_CUSTOM,
    DATE_RANGE_LAST_30_DAYS,
    DATE_RANGE_LAST_7_DAYS, DATE_RANGE_LAST_90_DAYS,
    DATE_RANGE_TODAY,
    DATE_RANGE_YESTERDAY
} from "../../../constants/dates";

export const getRangeFromDates = function (from, till) {
    if (!from && !till) {
        return DATE_RANGE_ANY;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayTimestamp = today.getTime() / 1000;

    const tonight = new Date();
    tonight.setHours(23, 59, 59, 999);
    const tonightTimestamp = tonight.getTime() / 1000;

    if (from === todayTimestamp && till === tonightTimestamp) {
        return DATE_RANGE_TODAY;
    }

    const yesterdayMorning = new Date();
    yesterdayMorning.setDate(yesterdayMorning.getDate() - 1);
    yesterdayMorning.setHours(0, 0, 0, 0);
    const yesterdayMorningTimestamp = yesterdayMorning.getTime() / 1000;
    const yesterdayNight = new Date();
    yesterdayNight.setDate(yesterdayMorning.getDate() - 1);
    yesterdayNight.setHours(23, 59, 59, 999);
    const yesterdayNightTimestamp = yesterdayNight.getTime() / 1000;
    if (from === yesterdayMorningTimestamp && till === yesterdayNightTimestamp) {
        return DATE_RANGE_YESTERDAY;
    }

    const lastWeekMorning = new Date();
    lastWeekMorning.setDate(lastWeekMorning.getDate() - 7);
    lastWeekMorning.setHours(0, 0, 0, 0);
    const lastWeekMorningTimestamp = lastWeekMorning.getTime() / 1000;
    if (from === lastWeekMorningTimestamp && till === tonightTimestamp) {
        return DATE_RANGE_LAST_7_DAYS;
    }

    const lastMonthMorning = new Date();
    lastMonthMorning.setMonth(lastMonthMorning.getMonth() - 1);
    lastMonthMorning.setHours(0, 0, 0, 0);
    const lastMonthMorningTimestamp = lastMonthMorning.getTime() / 1000;
    if (from === lastMonthMorningTimestamp && till === tonightTimestamp) {
        return DATE_RANGE_LAST_30_DAYS;
    }

    const lastQuarterMorning = new Date();
    lastQuarterMorning.setMonth(lastQuarterMorning.getMonth() - 3);
    lastQuarterMorning.setHours(0, 0, 0, 0);
    const lastQuarterMorningTimestamp = lastQuarterMorning.getTime() / 1000;
    if (from === lastQuarterMorningTimestamp && till === tonightTimestamp) {
        return DATE_RANGE_LAST_90_DAYS;
    }

    return DATE_RANGE_CUSTOM;
}
